<template>
  <div class="leftbar-view elffy-dashboard" :class="{'left-aside-toggle': toggle_aside}">
    <!--Page Container Start Here-->
    <section class="main-container">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-3">
            <smallBar :user="user"></smallBar>
          </div>
          <div class="col-md-9">
            <div class="widget-wrap">
              <div class="deal_sidebar block-header clearfix"><div class="pull-left"><p>公司資訊</p></div></div>
              <div class="widget-container">
                <div class="widget-content">
                  <div class="row">
                    <div class="col-md-4 col-md-offset-4 text-center" @click="uploadLogoModal=true">
                      <div class="pointer"  @click="uploadAvatarModal=true">
                        <img class="img-responsive" src="../../assets/img/logo1.png" alt="logo" height="60" v-if="company.logo==null">
                        <img class="img-responsive" v-bind:src="company.logo" v-else>
                        <small>點擊更換公司LOGO</small>
                        <br><br>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="text-left">
                        <div class="form-group">
                          <label class="control-label">公司名稱</label>
                          <input type="text" class="form-control" v-model="company.name">
                        </div>
                        <div class="form-group">
                          <label class="control-label">公司統編</label>
                          <input type="text" class="form-control" v-model="company.number">
                        </div>
                        <div class="form-group">
                          <label class="control-label">公司地址</label>
                          <input type="text" v-model="company.address" class="form-control">
                        </div>
                        <div class="form-group text-center">
                          <div class="col-md-12">
                            <div class="form-actions">
                              <button @click="updateCompany()" class="btn btn-primary">儲存</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <simplert :useRadius="true" :useIcon="true" ref="simplert">
    </simplert>
    
    <!-- modal template start-->
    <div v-if="uploadLogoModal" @keyup.esc="uploadLogoModal=false">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="uploadLogoModal=false">
          <div class="modal-container col-md-6" @click.stop>
            <div class="modal-header">
              <div name="header">
                上傳新的LOGO
              </div>
              <a href="#" class="btn-close" @click="uploadLogoModal = false">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body j-forms">
              <div class="form-group">
                <dropzone 
                  id="myVueDropzone" 
                  :url="axios.defaults.baseURL + '/settings/update_company'" 
                  :headers=auth_token
                  :maxFileSizeInMB='12'
                  @vdropzone-success="vsuccess"
                  >
                </dropzone>
              </div>
            </div>
            <div class="modal-footer j-forms">
              <div name="footer">
                <button class="btn btn-default" @click="uploadLogoModal = false">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
  </div>
</template>

<script>
import Simplert from 'vue2-simplert'
import smallBar from './SmallBar.vue';
import { getCookie, setCookie } from '../../assets/js/elffy_js/cookie.js'
import Dropzone from 'vue2-dropzone'

export default {
  name: 'company',
  components: { Simplert,Dropzone,smallBar },
  data() {
    return {
      company: '',
      uploadLogoModal: false,
      cards: '',
      email: '',
      refs: this.$refs,
      auth_token: '',
      target_year: (new Date().getFullYear()).toString(),
    }
  },
  created() {
    this.getCompany()
  },
  computed: {
    
  },
  props: ['toggle_aside','user'],
  methods: {
    getCompany() {
      // defiine vm to assign this (assign vue data) because in axios there is other this
      this.auth_token = { 'Auth-Token': getCookie('auth_token') }
      const vm = this;
      this.axios.get('settings/get_company').then(
        function(response) {
          if (response.status == 200 && response['data']['data']) {
            vm.company = response['data']['data']['company']
            vm.getCard();
          } else {
            console.log('Error')
          }
        }).catch(function(error) {
        console.log('error:', error)
      });
    },
    
    getCard() {
      // defiine vm to assign this (assign vue data) because in axios there is other this
      this.auth_token = { 'Auth-Token': getCookie('auth_token') }
      const vm = this;
      this.axios.get('users/get_card').then(
        function(response) {
          if (response.status == 200 && response['data']['data']) {
            vm.cards = response['data']['data']
          } else {
            console.log('Error card')
          }
        }).catch(function(error) {
        console.log('error:', error)
      });
    },
    getCardIcon(card) {
      return {
        'fab fa-cc-visa': card.card_type == "visa"
      }
    },
    updateCompany() {
      var vm = this
      this.axios.post('settings/update_company', {
        company: vm.company
      })
      .then(function(response) {
        if (response['data']['status'] == 'success') {
          var obj = {
            isShown: true,
            title: '更新成功',
            type: 'success',
            hideAllButton: true
          }
          vm.refs.simplert.openSimplert(obj);
        } else if (response['data']['status'] == 'fail') {
          var obj = {
            isShown: true,
            title: '更新失敗、請稍後再試',
            message: '更新失敗',
            type: 'error',
            customCloseBtnText: '關閉'
          }
          vm.refs.simplert.openSimplert(obj);
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    vsuccess(file, response) {
      this.company.logo = response["data"]
      this.uploadLogoModal = false
      var obj = {
        isShown: true,
        title: '更新成功',
        type: 'success',
        hideAllButton: true
      }
      this.$refs.simplert.openSimplert(obj);
    },
  },
}
</script>


// WEBPACK FOOTER //
// Company.vue?90d47688